/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { DialogRef } from '@ngneat/dialog';

@Component({
  selector: 'bkg-challenge-dialog',
  templateUrl: './challenge-dialog.component.html',
  styleUrls: ['./challenge-dialog.component.scss'],
})
export class ChallengeDialogComponent implements OnInit {
  targetUrl: SafeResourceUrl;

  constructor(
    public ref: DialogRef,
    private sanitizationService: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.targetUrl = this.sanitizationService.bypassSecurityTrustResourceUrl(
      this.ref.data?.url
    );
  }

  onClickClose(): void {
    this.ref.close();
  }
}
